import { IconAlertTriangle, IconFileX } from "@tabler/icons-react";
import { Alert, Card, Divider, Group, Stack, Text, ThemeIcon } from "@/components/ui";
import type { SatError } from "@/features/cargar-cfdi/types";

/**
 * Card de error del SAT · presentacional. Se monta tras detectar la transición de estado
 * durante el polling:
 *  · `RechazadoFiscal`: el SAT rechazó el CFDI (cancelado, EFOS, etc.).
 *  · `SuspendidaFiscal`: el SAT NO dio una respuesta definitiva (servicio caído, timeout o
 *    CFDI no consultable) · el CFDI no fue rechazado, solo no se pudo validar.
 */
export function SatErrorCard({ error }: { error: SatError }) {
  const rechazado = error.estado === "RechazadoFiscal";
  const titulo = rechazado ? "SAT rechazó el CFDI" : "No se pudo validar el CFDI con el SAT";
  const indicacion = rechazado
    ? "Sube otro CFDI o pide al proveedor que regularice su situación fiscal."
    : "El SAT no respondió o no se pudo consultar el CFDI. Vuelve a cargarlo en unos minutos; si persiste, verifica los datos del comprobante con el emisor.";
  return (
    <Card padding="lg">
      <Stack gap="md">
        <Group gap="sm" align="flex-start">
          <ThemeIcon variant="filled" color="multiva" size="lg">
            <IconFileX size={20} stroke={1.6} />
          </ThemeIcon>
          <div className="flex-1">
            <Text fw={600}>{titulo}</Text>
            <Text size="sm" c="dimmed">
              {indicacion}
            </Text>
          </div>
        </Group>
        <Divider />
        <Alert variant="error" icon={<IconAlertTriangle size={16} stroke={1.7} />}>
          <Stack gap={4}>
            {error.codigo && <code className="self-start rounded bg-muted px-1.5 py-0.5 font-mono text-[11px]">{error.codigo}</code>}
            <Text size="sm">{error.mensaje}</Text>
          </Stack>
        </Alert>
      </Stack>
    </Card>
  );
}
